import React from 'react';
import { Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import RiskCategoryMatrix from '../riskCategoryMatrix/RiskCategoryMatrix';
import { category_level } from '../../../constants/enums';
import './RiskCategoryLevels.scss';
const useStyles = makeStyles(() => ({
    customTooltip: {
        backgroundColor: 'white',
        width: '600px',
        minWidth: '600px',
        paddingTop: '32px',
        boxShadow: '2px 2px 4px 0 rgba(56, 58, 57, 0.08)',
    },
    customArrow: {
        color: 'rgba(220, 0, 78, 0.8)',
    },
}));
const RiskCategoryLevels = ({ category }) => {
    const categorylevel = category ? category_level[category] : 0;
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { classes: {
                tooltip: classes.customTooltip,
                arrow: classes.customArrow,
            }, title: React.createElement(RiskCategoryMatrix, { category: category }), placement: "left" },
            React.createElement("div", { className: `risk-category-levels category-level-${categorylevel}` },
                React.createElement(React.Fragment, null,
                    React.createElement("span", null),
                    React.createElement("span", null),
                    React.createElement("span", null),
                    React.createElement("span", null)),
                React.createElement("p", null, category || '--')))));
};
export default RiskCategoryLevels;
